// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const SectionAccordion = ({
  title,
  defaultExpanded = true,
  children,
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        border: `1px solid ${theme?.palette?.entityOverview?.borderLfetTightPanel}`,
        borderRadius: '4px',
        '&:before': { display: 'none' },
        overflow: 'hidden',
        m: 0,
        '&.Mui-expanded': {
          m: 0,
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{
              color: theme?.palette?.entityOverview?.IconColor,
              fontSize: 'large',
            }}
          />
        }
        sx={{
          minHeight: 45,
          px: 2,
          py: 1.5,
          background: theme?.palette?.entityOverview?.accordionTitleBackground,
          '& .MuiAccordionSummary-content': {
            margin: 0,
            alignItems: 'center',
          },
        }}
      >
        <Typography variant="body6">{title}</Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

SectionAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  defaultExpanded: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default SectionAccordion;
